var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_3656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 5.66675L9.33366 9.20841M13.3337 9.91675L9.33366 5.66675L8.00033 3.54175M14.667 3.54175H6.66699M11.3337 1.41675H10.667M7.39166 12.0417H2.60899M7.39166 12.0417L8.66699 14.8751M7.39166 12.0417L5.48146 7.79812C5.32753 7.45621 5.25059 7.28522 5.14526 7.23117C5.05373 7.18421 4.94693 7.18421 4.85539 7.23117C4.75006 7.28522 4.67313 7.45621 4.51919 7.79812L2.60899 12.0417M2.60899 12.0417L1.33366 14.8751",
    stroke: "url(#paint0_linear_2759_3656)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_3656",
    x1: 0.0508637,
    y1: 13.333,
    x2: 13.3108,
    y2: 15.7247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_3656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.c42153a7db67bb21a5364e5a969d18af.svg";
export { ForwardRef as ReactComponent };